import { Box, Grid, Typography } from '@mui/material'
import React, { useEffect } from 'react'
import CustomisedButton from '../../button/button'
import EmptyStyle from '../../emptyStyles/emptyStyle'
import { useDispatch } from 'react-redux'
import { getNextInnerState, getpervInnerState } from '../../../redux/handleBackBtn/handleBackBtnSlice'
import { title } from 'process'
import { values } from 'lodash'
import { useQueryClient } from 'react-query'
import { useNavigate } from 'react-router-dom'
import { GATEWAY_PAYMENT_TOKEN, PAYMENT_VALUE } from '../../../config/cacheKey'
import { string } from 'yup'

const FuturePassedLoansCard = ({ date, price, status, textColor, paymentDatePersian, amount, penaltyAmount, gatewayPaymentToken, gateway, transactionCode, traceNumber, settledInstallment }
    : { date: string, price: number, status: string, textColor: string, paymentDatePersian: string, amount: number, penaltyAmount?: number, gatewayPaymentToken?: string, gateway?: string, transactionCode?: string, traceNumber?: string, settledInstallment?: boolean }) => {
    useEffect(() => {
        queryClient.setQueryData(PAYMENT_VALUE, null);
    }, [])
    const queryClient = useQueryClient();
    const paymentArray = [
        {
            title: 'شماره پیگیری :',
            value: transactionCode
        },
        {
            title: 'تاریخ و زمان پرداخت :',
            value: paymentDatePersian
        },
        {
            title: 'مبلغ قسط (ریال)',
            value: amount
        },
        {
            title: 'جریمه دیرکرد (ریال)',
            value: penaltyAmount
        }
    ];
    const paymentData = { amount: amount, penaltyAmount: penaltyAmount, paymentDatePersian: paymentDatePersian, trackingNumber: traceNumber, gateway: gateway, paymentStatus: 'Verified', settledInstallment: settledInstallment }
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const handleContinue = () => {
        queryClient.setQueryData(PAYMENT_VALUE, paymentData);
        navigate('/loans/installments/payment');
        localStorage.setItem(GATEWAY_PAYMENT_TOKEN, gatewayPaymentToken!);
    }


    return (
        status === 'setteled' && date === '' ?
            <Grid container sx={{ alignItems: "center", border: "1px solid #D7DBEC", borderRadius: "5px", background: "#fff", padding: "10px 20px", minHeight: "40vh" }}>
                <EmptyStyle emphasisedWordsColor="" icon={<img src='images/emptyInstallment.svg' style={{ paddingLeft: "5px" }}></img>} text="قسط پرداخت شده ای ندارید" emphasisedWords={[]}
                    textColor={textColor} />
            </Grid> :
            <Grid container sx={{ alignItems: "center", border: "1px solid var(--border-color)", borderRadius: "5px", background: "var(--input-bg-color)", padding: "5px 20px", minHeight: "40px" }}>
                <Grid item xs={8} sx={{ display: "flex", flexDirection: "column" }}>
                    <Grid item>
                        <Typography sx={{ color: penaltyAmount ? "#FF617C" : "var(--primary-text-color)", fontSize: "0.9rem" }}>
                            {date}
                        </Typography>
                    </Grid>
                    <Grid item>
                        <Typography sx={{ color: penaltyAmount ? "#FF617C" : "var(--primary-text-color)", fontSize: "1rem", fontWeight: "bold", letterSpacing: "1px" }}>
                            {price.toLocaleString('fa')}{" "} <span style={{ letterSpacing: "normal", color: penaltyAmount ? "#FF617C" : "var(--primary-text-color)", fontSize: ".9rem", fontWeight: "normal" }}>ریال</span>
                        </Typography>
                    </Grid>
                </Grid>
                {(status === 'setteled' || status === 'Verified') &&
                    <Grid item xs={4}>
                        <CustomisedButton disable={false} onClick={() => handleContinue()} title='رسید پرداخت' type='button' />
                    </Grid>}
            </Grid>

    )
}

export default FuturePassedLoansCard
